import {JackpotTypes} from "../enums";
import {T} from "./translation-keys";

export const JackpotTypeNames = {
  [JackpotTypes.Mega]: T.MEGA,
  [JackpotTypes.Betshop]: T.BETSHOP,
  [JackpotTypes.Game]: T.GAME,
};